import { render, staticRenderFns } from "./StarboardFuelCharacteristics.vue?vue&type=template&id=b83e1ad6&scoped=true"
import script from "./StarboardFuelCharacteristics.vue?vue&type=script&lang=js"
export * from "./StarboardFuelCharacteristics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83e1ad6",
  null
  
)

export default component.exports